var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('Modal', {
    staticClass: "proview_img",
    attrs: {
      "width": "900",
      "mask-closable": false,
      "title": _vm.title,
      "footer-hide": ""
    },
    on: {
      "on-cancel": function ($event) {
        return _vm.$emit('close');
      }
    },
    model: {
      value: _vm.modal.visible,
      callback: function ($$v) {
        _vm.$set(_vm.modal, "visible", $$v);
      },
      expression: "modal.visible"
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.url,
      "alt": "",
      "width": "100%"
    }
  })]);
};
var staticRenderFns = [];
export { render, staticRenderFns };